/**
 * @fileoverview Feature flag utilities for gradual rollout of features
 */

import { CHAT_AGENT_SHORT_NAME } from "@/constants/agents";
import { AgentInstance } from "@/types/agent";

/**
 * Check if a tenant is enabled for the global chat feature
 * Reads from VITE_GLOBAL_CHAT_ENABLED_TENANTS environment variable
 * @param tenantId - The tenant ID to check
 * @returns boolean - True if tenant is enabled for global chat
 */
export function isGlobalChatEnabledForTenant(tenantId: string | undefined): boolean {
  if (!tenantId) return false;

  const enabledTenants = import.meta.env.VITE_GLOBAL_CHAT_ENABLED_TENANTS;
  
  if (!enabledTenants) return false;

  // Split by comma and trim whitespace, then check if tenant ID exists
  const tenantList = enabledTenants
    .split(',')
    .map((id: string) => id.trim())
    .filter((id: string) => id.length > 0);

  return tenantList.includes(tenantId);
}

/**
 * Get the chat workflow instance ID 
 * @param agentInstances - List of agent instances for the tenant
 * @returns string - The workflow instance ID for the tenant
 */
export function getChatWorkflowInstanceId(agentInstances: AgentInstance[] | undefined ): string {
    
  // Look for an agent instance with short_name 'global-chat-agent'
  const chatAgentInstance = agentInstances?.find(
    (instance) => instance?.agent?.short_name === CHAT_AGENT_SHORT_NAME
  );

  if (chatAgentInstance && chatAgentInstance.workflow_instances && chatAgentInstance.workflow_instances.length > 0) {
    // Return the first workflow instance ID - Assuming only one per agent instance
    return chatAgentInstance.workflow_instances[0].id;
  }

  return "";
}
